import styled from 'styled-components'

export const MainContainer = styled.div`
    display: block;
    width: 100%;
`

export const ChartContainer = styled.div``

export const ContentContainerHeader = styled.h1`
    margin: 0.8em 1.4em;
    text-transform: uppercase;
    font-size: 1em;
    font-weight: bold;
    font-family: Myraid Pro, sans-serif;
    line-height: 1.5;
`

export const ContentContainer = styled.div<{ width: number }>`
    font-size: ${({ width }) => (width < 470 ? '0.75em' : '1em')};
    min-height: 200px;
    margin: 16px 22px;
    padding: 24px;
    background: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px 0px,
        rgba(0, 0, 0, 0.23) 0px 3px 6px 0px;
    border-radius: 20px;
`
